import {
  DATA_QUALITY_WORKFLOWS_CATEGORY,
  EVAL_PANTRY_TUNING_CATEGORY,
  REVIEW_OUTPUTS_CATEGORY,
  SETTINGS_DATA_QUALITY_HASHES,
} from './adminConfigConstants.js'

export function readSettingsDeepLinkHash() {
  const hash = window.location.hash?.replace('#', '') || ''
  return SETTINGS_DATA_QUALITY_HASHES.has(hash) ? hash : null
}

export function isSettingsDataQualityHash(hash) {
  return SETTINGS_DATA_QUALITY_HASHES.has(hash)
}

export function scrollToSettingsDeepLink(hash, { behavior = 'smooth' } = {}) {
  if (!hash) return false
  const el = document.getElementById(hash)
  if (!el) return false
  el.scrollIntoView({ behavior, block: 'start' })
  return true
}

/** Category id → short label for the Settings top nav (single-line strip). */
export const SETTINGS_CATEGORY_NAV_LABELS = {
  routing: 'Routing',
  rag: 'RAG',
  agent: 'Agent',
  grocery: 'Grocery',
  cache: 'Cache',
  system: 'System',
  features: 'Flags',
  models: 'Models',
  preferences: 'Prefs',
  [EVAL_PANTRY_TUNING_CATEGORY]: 'Eval',
  [DATA_QUALITY_WORKFLOWS_CATEGORY]: 'Workflows',
  [REVIEW_OUTPUTS_CATEGORY]: 'Outputs',
}

export function settingsCategoryNavLabel(categoryId, fallbackName) {
  return SETTINGS_CATEGORY_NAV_LABELS[categoryId] || fallbackName || categoryId
}

export const APP_NAVIGATE_SETTINGS_EVENT = 'app:navigate-settings'

/** Cold-load / URL-bar state when landing on /account#pantry-match-review (etc.). */
export function readInitialAccountNavigation() {
  const hash = readSettingsDeepLinkHash()
  if (!hash) return null
  return {
    accountSubTab: 'system-admin',
    systemSubTab: 'config',
    hash,
  }
}

/** In-app navigation to Settings → Workflows without a full document reload. */
export function requestSettingsDeepLinkNavigation(hash) {
  if (typeof window === 'undefined' || !isSettingsDataQualityHash(hash)) return
  window.location.hash = hash
  window.dispatchEvent(new CustomEvent(APP_NAVIGATE_SETTINGS_EVENT, { detail: { hash } }))
}
